import { createAsyncActionTypes } from 'src/core/util/async-action-type-creator';

export const GET_SCHEDULE_HOME = createAsyncActionTypes('GET_SCHEDULE_HOME');
export const SET_DOCUMENT_ACKNOWLEDGE = createAsyncActionTypes(
  'SET_DOCUMENT_ACKNOWLEDGE',
);
